import gql from 'graphql-tag';

const baseMeetingsFields = `
    id,
    createTime,
    advisorId,
    advisor {
        id,
        name,
        firstName,
        lastName
    },
    studentId,
    student {
        id,
        name,
        firstName,
        lastName,
        phone,
        mobilePhone
    },
    advisorRequested,
    startTime,
    endTime,
    reasonId,
    roomId,
    meetingTimer,
    noShowTime,
    preferredPhoneNumber,
    additionalInformation,
    status,
    vipEscalationFlag,
`;

export default {
    MEETINGS_QUERY: gql`
        query Meetings($roomId: String, $roomName: String) {
            meetings(roomId: $roomId, roomName: $roomName) {
                ${baseMeetingsFields}
            }
        }`,
    MEETINGS_SUBSCRIPTION: gql`
        subscription Meetings($roomId: String, $roomName: String) {
            meetings(roomId: $roomId, roomName: $roomName) {
                ${baseMeetingsFields}
            }
        }`,
    MEETINGS_MUTATION: gql`
        mutation Meeting($additionalInformation: String, $advisorId: String, $advisorRequested: String, $preferredPhoneNumber: String, $reasonId: String, $roomId: String, $studentId: String) {
            meeting(additionalInformation: $additionalInformation, advisorId: $advisorId, advisorRequested: $advisorRequested, preferredPhoneNumber: $preferredPhoneNumber, reasonId: $reasonId, roomId: $roomId, studentId: $studentId) {
                id,
            }
        }`,
};



// WEBPACK FOOTER //
// ./src/graphql-operations/meetings.graphql.js